import { _AbcGridColumn } from '@barthauer/abc/ui-components';
import { DataSource } from 'devextreme/common/data';

export class CategoryViewDefinition {
  columnInfos: _AbcGridColumn[];
  dataSource: DataSource;
}

export class ActionButton {
  caption: string;
  action: () => Promise<void>;
  icon?: string;
  tooltip?: string;
}

export enum UiSettings {
  popupWidth = '70vw',
  popupHeight = '80%',
  popupMinWidth = 840,
  popupMinHeight = 420,
  categoryListMinWith = 200,
  viewMinWidth = 500,
}
